import { AccessDeniedError, UnexpectedError, UnexpectedResultFormatError } from '@/domain/errors'
import { PortalContatoPermissoes } from '@/domain/usecases'
import { HttpClient, HttpRequest, HttpStatusCode } from '@/data/protocols/http'

export class RemoteGetContatoPermissoes implements PortalContatoPermissoes {
  constructor (
    private readonly url: string,
    private readonly httpClient: HttpClient<PortalContatoPermissoes.Result>
  ) {}

  async get (params: PortalContatoPermissoes.Params): Promise<PortalContatoPermissoes.Result> {
    const authParams: HttpRequest = {
      url: `${this.url}/api/portal/contatos/permissoes`,
      method: 'get',
      params
    }

    const { statusCode, body } = await this.httpClient.request(authParams)

    switch (statusCode) {
      case HttpStatusCode.ok: {
        if (body === null) {
          throw new UnexpectedResultFormatError()
        }
        return body
      }
      case HttpStatusCode.badRequest: throw new UnexpectedError()
      case HttpStatusCode.unauthorized: throw new AccessDeniedError()
      default: throw new UnexpectedError()
    }
  }
}
